module.exports = __webpack_public_path__ + "img/avatar_2.10be842b.png";